<template>
  <div id="mse"></div>
</template>
<script>
import "xgplayer";
import HlsPlayer from "xgplayer-hls";
// import FlvPlayer from 'xgplayer-flv';
export default {
  props: ["url", "danmu", "showDanmu"],
  data() {
    return {
      player: null,
      timer: new Date().getTime(),
      overdanmu: [],
    };
  },
  watch: {
    showDanmu(val) {
      if (val == true) {
        this.player.danmu.stop(); // 弹幕停止并消失
      } else {
        this.player.danmu.play(); // 弹幕继续播放
        // player.danmu.start() //弹幕初始化并播放(内部默认已调用)
      }
    },
    danmu(newValue, oldValue) {
      if (!(this.player && this.player.danmu)) {
        return;
      }
      this.danmu.forEach((it) => {
        let tim = new Date(it.create_time).getTime() - this.timer;
        if (tim < 0) {
          tim = 3000;
        }
        this.player.danmu.sendComment({
          // 发送弹幕
          duration: 15000,
          id: it.id,
          // start: 3000,
          start: tim,
          txt: it.detail,
          style: {
            color: "#ff9500",
            fontSize: "20px",
            border: "solid 1px #ff9500",
            borderRadius: "50px",
            padding: "5px 11px",
            backgroundColor: "rgba(255, 255, 255, 0.1)",
          },
        });
      });
      // this.player.danmu.updateComments(commonents, true) // 更新弹幕数据（isClear默认为true，表示清空旧数据）
    },
  },
  beforeDestroy() {
    this.player.destroy(true);
  },
  mounted() {
    this.player = new HlsPlayer({
      id: "mse",
      width: "100%",
      height: "100%",
      isLive: true,
      ignores: ["time", "progress"],
      preloadTime: 30,
      minCachedTime: 5,
      lang: "zh-cn",
      url: this.url, // 'https://live-down.gymooit.cn/train-4921129561856cff94197cd7aff5ac70/train-22.flv?auth_key=1636973747-0-0-a164e4c9e9fd3bfc9ec533787cd89305'
      danmu: {
        panel: false, // 弹幕面板
        comments: [],
        area: {
          // 弹幕显示区域
          start: 0, // 区域顶部到播放器顶部所占播放器高度的比例
          end: 1, // 区域底部到播放器顶部所占播放器高度的比例
        },
        closeDefaultBtn: true, // 开启此项后不使用默认提供的弹幕开关，默认使用西瓜播放器提供的开关
        defaultOff: false, // 开启此项后弹幕不会初始化，默认初始化弹幕
      },
    });
    // this.player.danmu.start() //弹幕初始化并播放(内部默认已调用)
    this.danmu.forEach((it) => {
      this.player.danmu.sendComment({
        // 发送弹幕
        duration: 15000,
        id: it.id,
        start: 3000,
        txt: it.detail,
        style: {
          color: "#ff9500",
          fontSize: "20px",
          border: "solid 1px #ff9500",
          borderRadius: "50px",
          padding: "5px 11px",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
        },
      });
    });
    // const commonents = this.danmu.map(item => {
    //     return {
    //         duration: 8000, // 弹幕持续显示时间,毫秒(最低为5000毫秒)
    //         id: item.id, // 弹幕id，需唯一
    //         start: 3000, // 弹幕出现时间，毫秒
    //         prior: true, // 该条弹幕优先显示，默认false
    //         color: true, // 该条弹幕为彩色弹幕，默认false
    //         txt: item.detail, // 弹幕文字内容
    //         style: { // 弹幕自定义样式
    //             color: '#ff9500',
    //             fontSize: '20px',
    //             border: 'solid 1px #ff9500',
    //             borderRadius: '50px',
    //             padding: '5px 11px',
    //             backgroundColor: 'rgba(255, 255, 255, 0.1)'
    //         },
    //         mode: 'scroll'
    //     }
    // })
    // this.player.danmu.updateComments(commonents, true) // 更新弹幕数据（isClear默认为true，表示清空旧数据）
  },
};
</script>
<style>
.xgplayer-skin-default .xgplayer-panel-slider {
  bottom: 40px;
  font-size: 12px;
  height: auto;
}
#mse {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
